import "./App.css";
import "./styles/css/styles.css";
import Portfolio from "./components/Portfolio";
function App() {
   return <Portfolio />;
}

export default App;
